<ng-container *ngIf="action$ | async as action">
    <ng-container *ngIf="actionState$ | async as state">
    <div [pTooltip]="state.tooltip" tooltipPosition="left">
      <p-button
        icon="pi pi-plus"
        [label]="description"
        ntapDebounceClick
        (onClick)="executeAction($event)"
        [disabled]="state.disabled"
        [ngClass]="{'hide-label-responsive': true}"
      ></p-button>
    </div>
    </ng-container>
</ng-container>